import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faSquare, faSquareCheck } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { StyledCheckBox, StyledFormControlLabel } from "./FormCheckbox.styled"
import { IFormCheckboxProps } from "./formchecklist.interfaces"
import { useTranslation } from "react-i18next"
import { fontAwesomeOldXlStyle } from "components/icons/fontAwesomeStyles"

const FormCheckbox: React.FC<IFormCheckboxProps> = (props) => {
  const { id, labelKey, labelDefault, value, handleChange } = props
  const [checkedItem, setCheckedItem] = useState<boolean>(false)
  const { t } = useTranslation()

  useEffect(() => {
    setCheckedItem(value)
  }, [value])
  const setCheckbox = () => {
    handleChange && handleChange(!checkedItem)
  }

  return (
    <StyledFormControlLabel
      key={id}
      control={
        <StyledCheckBox
          icon={<FontAwesomeIcon style={fontAwesomeOldXlStyle} icon={faSquare as IconProp} />}
          checkedIcon={<FontAwesomeIcon style={fontAwesomeOldXlStyle} icon={faSquareCheck as IconProp} />}
          checked={checkedItem}
          onChange={() => setCheckbox()}
          value={checkedItem}
        />
      }
      label={
        <Typography lineHeight={"120%"} variant="labelMedium" fontWeight={500}>
          {t(labelKey || "", { defaultValue: labelDefault })}
        </Typography>
      }
    />
  )
}

export default FormCheckbox
